import React, { useState, useRef } from "react";
import classnames from "classnames/bind";
import style from "./index.module.scss";
import OilThumb from "../../OilThumb";
import OilBaseInfomation from "../../OilBaseInfomation";
import OilVolumesService from "../../OilVolumesService"
import Printable from '../../RecommendationPrintable/Product';
import { useReactToPrint } from 'react-to-print';
import {
  IComponentVolumes,
  IModal,
  IProd,
  IServiceIntervals,
  IState,
  ProductCategory,
  Replacement,
} from "../../../interface";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import actions from "../../../redux/actions";
import _ from "lodash";
import Modal from "../../Modal";
import { ModalHref } from "../../../interface/emnu";
import Information from "../../ProductInformation/Information";
import {useSearchParams} from 'react-router-dom';
import { useAppName } from "../../../hooks/use-app-names";
import { APPNAME, FASTSCAN } from "../../../constants";

const cx = classnames.bind(style);

interface IProps {
  modal: IModal;
  setModal: (value: IModal) => void;
  replacements: Replacement;
  dataList: IProd;
  productCategories: ProductCategory[];
  vehicleComponentVolumes: IComponentVolumes[];
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  componentName: string | undefined;
  vehicle?:any,
  notes?: string[]
}

export const AlternativeRecommendation = (props: IProps) => {
  const {
    modal,
    setModal,
    replacements,
    dataList,
    productCategories,
    vehicleComponentVolumes,
    setServiceIntervals,
    setVehicleComponentVolumes,
    componentName,
    vehicle,
    notes
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const ref = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const window: any = globalThis;
  window.dataLayer = window.dataLayer || [];
  const moreLinkClick = () => {
    setServiceIntervals(dataList.serviceIntervals);
    setVehicleComponentVolumes(vehicleComponentVolumes);
    searchParams.set('id', _.toString(dataList.id));
    searchParams.set('page', 'product');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const [modalVisuble, setModalVisible] = useState<boolean>(false);

  const printOptions = {
    content: () => ref?.current,
    copyStyles: true,
  }
  const handlePrint = useReactToPrint(printOptions);

  return (
    <>
      <Printable
        title="Alternative Recommendation"      
        ref={ref}
        vehicle={vehicle}
        componentName={componentName || ''}
        volumes={vehicleComponentVolumes}
        notes={notes}
        data={dataList}
      />
      <div className={cx("section")}>
        <h4 className={cx('section-title')}>{dataList['name']}</h4>
        <div className={cx('inner')}>
          <div className={cx("sider")}>
            <OilThumb
              withoutMoreLink={true} 
              dataList={dataList}
              moreLinkClick={moreLinkClick}
              onPrintClick={handlePrint}
              vehicleP={vehicle}
              products={dataList}
              componentName={componentName}
              Recommendation="alternative recommendation"
            />
          </div>
          <div className={cx("content")}>
            <OilBaseInfomation
              withoutMoreLink={false}
              dataList={dataList}
              productCategories={productCategories}
              moreLinkClick={moreLinkClick}
              onPrintClick={handlePrint}
              vehicle={vehicle}
              products={dataList}
              componentName={componentName}
              openModalHandle={() => {
                setModal({ visibie: true, href: ModalHref.ReadMore });
                setModalVisible(true);
                setVehicleComponentVolumes(vehicleComponentVolumes);
              }}
              withTitle={true}
            />
            <OilVolumesService
              notes={notes}
              withoutMoreLink={true}
              dataList={dataList}
              moreLinkClick={moreLinkClick}
            />
          </div>
          </div>
      </div>
      {_.isEqual(modal.href, ModalHref.ReadMore) &&
        modal.visibie &&
        modalVisuble && (
          <Modal
            className={cx("abs-modal")}
            dismiss={() => setModalVisible(false)}
          >
            <div className={cx("modal-content")}>
              <button
                className={cx("modal-close")}
                onClick={() => {
                  setModalVisible(false);
                  setModal({ visibie: false, href: 0 });
                }}
              >
                Close
              </button>
              <Information
                notes={notes}
                replacements={replacements}
                dataList={dataList}
                productCategories={productCategories ? productCategories : []}
              />
            </div>
          </Modal>
        )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  modal: state.modal,
  replacements: state.replacements,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlternativeRecommendation);
